// src/features/authV2/model/store.ts

import { AuthLoginModalViewInnerProps } from "@features/authV2/ui/AuthLoginModalView.tsx";
import { openContextModal } from "@mantine/modals";
import log from "loglevel";
import { create } from "zustand";

/**
 * @interface LoginModalStore
 * @description Состояние модального окна входа
 * @property {boolean} isOpen - Флаг, открыто ли модальное окно
 * @property {function} open - Функция для открытия модального окна
 * @property {function} close - Функция для закрытия модального окна
 */
interface LoginModalStore {
	isOpen: boolean;
	open: () => void;
	close: () => void;
}

/**
 * Zustand store для управления состоянием модального окна входа.
 * Позволяет открывать и закрывать модальное окно из любой части приложения.
 */
export const useLoginModalStore = create<LoginModalStore>((set) => ({
	isOpen: false,
	open: () => {
		log.debug("Opening login modal");
		set({ isOpen: true });
	},
	close: () => {
		log.debug("Closing login modal");
		set({ isOpen: false });
	}
}));

/**
 * Открывает модальное окно входа из не-React контекста.
 * Эта функция напрямую вызывает метод `open` из Zustand store.
 * Полезна для интеграции с устаревшим кодом или внешними SDK.
 */
export const openLoginModalFromExternal = (props?: AuthLoginModalViewInnerProps) => {
	log.debug("Triggering login modal open from non-React context");
	openContextModal({
		modal: "loginModal",
		innerProps: props,
		overlayProps: {
			backgroundOpacity: 0.55,
			blur: 3
		},
		size: "auto",
		withCloseButton: false,
		padding: 0,
		radius: "md",
		centered: true
	});
};
